const defaultAssessmentData = {
    calculationUnit: '+',
    calculationTypes: [
        { title: 'Absent', color: '#D7D7D7', value: 0, default: true },
        { title: 'Poor', color: '#DF4B65', value: -1, default: false },
        { title: 'Good as expected', color: '#F5BB00', value: 1, default: false },
        { title: 'Exceptional', color: '#52C05E', value: 1.5, default: false }
    ],
    accessLevel:[{"label":"Participant","key":0},{"label":"Leader","key":1},{"label":"Hr","key":2}],
    appraisalData: {
        // 'GOALS': [
        //         { title: 'KPIs', value: '10', key: 'KP', desc:'(Reflect on the goals set and assess the extent to which they were achieved)' },
        //         { title: 'QUALITY', value: '10', key: 'QU', desc:'(Evaluate the quality and accuracy of your contribution, considering any feedback received)' },
        //         { title: 'IMPACT', value: '10', key: 'IM', desc:'(Reflect on how your work contributed to the overall goals and success measures)' },
        //     ],
            'KNOWLEDGE': [
                { title: 'STRENGTHS', value: '15', key: 'SR', desc: '(Reflect on key strengths and areas for improvement in context of the role.)' },
                { title: 'LEARNING', value: '15', key: 'LR', desc: '(Evaluate efforts to acquire skills or knowledge through training, courses, self-study.)' },
                { title: 'APPLICATION OF SKILLS', value: '15', key: 'AS', desc: '(Did you get opportunity to apply acquired skills or knowledge to your work)' },
            ],
            'BEHAVIOUR': [
                { title: 'COMMUNICATION', value: '5', key: 'CM', desc: '(Reflect on your ability to listen actively, and communicate appropriately in professional dialogue.)' },
                { title: 'COLLABORATION', value: '5', key: 'CL', desc: '(Assess your ability to maintain positive working relationships, and contribute to teamwork.)' },
                { title: 'SUPPORT', value: '5', key: 'SR', desc: '' },
            ],
            'HEALTH': [
                { title: 'EMOTIONAL HEALTH', value: '5', key: 'EH', desc:'(Think about emotional intelligence, empathy towards self and other, constructive conflict resolutions)' },
                { title: 'RESILIENCE', value: '5', key: 'RS', desc:'(Assess your outlook on positivity, stress with change, and recovery from setbacks)' },
                { title: 'GROWTH APTITUDE', value: '5', key: 'GA', desc:'(Reflect on how secure you feel in your career, think of your participations in learning programs, adaptability)' },
            ],
            'CREATIVITY' : [
                { title: 'INNOVATION', value: '5', key: 'IV', desc:'(Out of box thinking, freedom of expression and innovation at work)' },
                { title: 'PROBLEM SOLVING', value: '5', key: 'PS', desc:'(Reflect on your ability to solve problems and generate innovative solutions.)' },
                { title: 'INITIATIVE', value: '5', key: 'IT', desc:'(Assess how often you took initiative to improve processes, suggest new ideas, or take on additional responsibilities)' },
            ],
            '' : [
                {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
            ]
    },
    fitmentData: {
        'ABILITY': [
            { title: 'FUNCTIONAL READINESS', value: '10', key: 'FR', desc: 'Has functional skills as per the role' },
            { title: 'ROLE KNOWLEDGE', value: '10', key: 'RK', desc: 'Has relevant role knowledge to perform tasks' },
            { title: 'RELEVANT EXPERIENCE', value: '10', key: 'RE', desc: 'Has experience to manage optimum performance' },
        ],
        'ASPIRATION': [
            { title: 'INTEREST', value: '10', key: 'IR', desc: 'Interest (Do they want to move?)' },
            { title: 'MOBILITY', value: '10', key: 'MO', desc: 'Mobility (Can they move?)' },
            { title: 'SUPPORT', value: '10', key: 'SP', desc: 'Has support to manage optimal performance' },
        ],
        'ATTITUDE': [
            { title: 'BEHAVIOURAL ATTRIBUTES', value: '10', key: 'BA', desc: 'Has behavioural attributes matching the need of the role' },
            { title: 'COGNITIVE COMPLEXITY', value: '10', key: 'CC', desc: 'Has the cognitive complexity to understand the needs' },
            { title: 'LEARNING APTITUDE', value: '10', key: 'LA', desc: 'Had learning aptitude to quickly learn role specific' },
        ],
        '': [
            {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
        ]
    },
    successionData: {
        'AGILITY': [
            { title: 'TRANSITION ABILITY', value: '10', key: 'TA', desc: '' },
            { title: 'KNOWLEDGE READINESS', value: '10', key: 'KR', desc: '' },
            { title: 'RELEVANT EXPERIENCE', value: '10', key: 'RE', desc: '' },
        ],
        'ADAPTABILITY': [
            { title: 'EMOTIONAL INTELLIGENCE', value: '10', key: 'EI', desc: '' },
            { title: 'RESILIENCE', value: '10', key: 'RL', desc: '' },
            { title: 'LEARNING APTITUDE', value: '10', key: 'LA', desc: '' },
        ],
        'ALERTNESS': [
            { title: 'GENERAL AWARENESS', value: '10', key: 'GA', desc: '' },
            { title: 'CRITICAL THINKING', value: '10', key: 'CT', desc: '' },
            { title: 'GENERAL KNOWLEDGE', value: '10', key: 'GK', desc: '' },
        ],
        '': [
            {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
        ]
    },
    performanceData: {
        'GOALS': [
                { title: 'KPIs', value: '10', key: 'KP', desc:'(Reflect on the goals set and assess the extent to which they were achieved)' },
                { title: 'QUALITY', value: '10', key: 'QU', desc:'(Evaluate the quality and accuracy of your contribution, considering any feedback received)' },
                { title: 'IMPACT', value: '10', key: 'IM', desc:'(Reflect on how your work contributed to the overall goals and success measures)' },
            ],
        'SKILL': [
            { title: 'IQ', value: '10', key: 'IQ', desc: 'Intelligence Quotient to operate as per the complexity of the role' },
            { title: 'TQ', value: '10', key: 'TQ', desc: 'Technical Quotient to have necessary skills to work on tasks' },
        ],
        'WILL': [
            { title: 'XQ', value: '10', key: 'XQ', desc: 'Experience within the role with required functional and behavioural abilities' },
            { title: 'MQ', value: '10', key: 'MQ', desc: 'Motivation and willingness to operate in the role with drive' },
        ],
        'EFFORT': [
            { title: 'PQ', value: '10', key: 'PQ', desc: 'Performance demonstrated in the role previously' },
            { title: 'LQ', value: '10', key: 'LQ', desc: 'Learning as per the situation and dedicating time for personal and professional growth' },
        ],
        '': [
            {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
        ]
    },
}

const assessmentData = [
    {
        orgId: '6512fc951aa789001abd5ed4',
        calculationUnit: '+',
        calculationTypes: [
            { title: 'Absent', color: '#D7D7D7', value: 0, default: true },
            { title: 'Poor', color: '#DF4B65', value: -1, default: false },
            { title: 'Good, as expected', color: '#F5BB00', value: 1, default: false },
            { title: 'Exceptional', color: '#52C05E', value: 1.25, default: false }
        ],
        accessLevel:[{"label":"Participant","key":0},{"label":"Leader","key":1},{"label":"Hr","key":2}],
        appraisalData: {
            'GOALS': [
                { title: 'KPIs', value: '10', key: 'KP', desc:'(Reflect on the goals set and assess the extent to which they were achieved)' },
                { title: 'QUALITY', value: '10', key: 'QU', desc:'(Evaluate the quality and accuracy of your contribution, considering any feedback received)' },
                { title: 'IMPACT', value: '10', key: 'IM', desc:'(Reflect on how your work contributed to the overall goals and success measures)' },
            ],
            'KNOWLEDGE': [
                { title: 'STRENGTHS', value: '5', key: 'SR', desc: '(Reflect on key strengths and areas for improvement in context of the role.)' },
                { title: 'LEARNING', value: '5', key: 'LR', desc: '(Evaluate efforts to acquire skills or knowledge through training, courses, self-study.)' },
                { title: 'APPLICATION OF SKILLS', value: '5', key: 'AS', desc: '(Did you get opportunity to apply acquired skills or knowledge to your work)' },
            ],
            'BEHAVIOUR': [
                { title: 'COMMUNICATION', value: '5', key: 'CM', desc: '(Reflect on your ability to listen actively, and communicate appropriately in professional dialogue.)' },
                { title: 'COLLABORATION', value: '5', key: 'CL', desc: '(Assess your ability to maintain positive working relationships, and contribute to teamwork.)' },
                { title: 'SUPPORT', value: '5', key: 'SR', desc: '' },
            ],
            'HEALTH': [
                { title: 'EMOTIONAL HEALTH', value: '5', key: 'EH', desc:'(Think about emotional intelligence, empathy towards self and other, constructive conflict resolutions)' },
                { title: 'RESILIENCE', value: '5', key: 'RS', desc:'(Assess your outlook on positivity, stress with change, and recovery from setbacks)' },
                { title: 'GROWTH APTITUDE', value: '5', key: 'GA', desc:'(Reflect on how secure you feel in your career, think of your participations in learning programs, adaptability)' },
            ],
            'CREATIVITY' : [
                { title: 'INNOVATION', value: '5', key: 'IV', desc:'(Out of box thinking, freedom of expression and innovation at work)' },
                { title: 'PROBLEM SOLVING', value: '5', key: 'PS', desc:'(Reflect on your ability to solve problems and generate innovative solutions.)' },
                { title: 'INITIATIVE', value: '5', key: 'IT', desc:'(Assess how often you took initiative to improve processes, suggest new ideas, or take on additional responsibilities)' },
            ],
            '' : [
                {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
            ]
        },
fitmentData: {
    'ABILITY' : [
        { title: 'FUNCTIONAL READINESS', value: '10', key: 'FR', desc: 'Has functional skills as per the role' },
        { title: 'ROLE KNOWLEDGE', value: '10', key: 'RK', desc: 'Has relevant role knowledge to perform tasks' },
        { title: 'RELEVANT EXPERIENCE', value: '10', key: 'RE', desc: 'Has experience to manage optimum performance' },
    ],
        'ASPIRATION' : [
            { title: 'INTEREST', value: '10', key: 'IR', desc: 'Interest (Do they want to move?)' },
            { title: 'MOBILITY', value: '10', key: 'MO', desc: 'Mobility (Can they move?)' },
            { title: 'SUPPORT', value: '10', key: 'SP', desc: 'Has support to manage optimal performance' },
        ],
            'ATTITUDE' : [
                { title: 'BEHAVIOURAL ATTRIBUTES', value: '10', key: 'BA', desc: 'Has behavioural attributes matching the need of the role' },
                { title: 'COGNITIVE COMPLEXITY', value: '10', key: 'CC', desc: 'Has the cognitive complexity to understand the needs' },
                { title: 'LEARNING APTITUDE', value: '10', key: 'LA', desc: 'Had learning aptitude to quickly learn role specific' },
            ],
                '': [
                    {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
                ]
},
successionData: {
    'AGILITY' : [
        { title: 'TRANSITION ABILITY', value: '10', key: 'TA', desc: '' },
        { title: 'KNOWLEDGE READINESS', value: '10', key: 'KR', desc: '' },
        { title: 'RELEVANT EXPERIENCE', value: '10', key: 'RE', desc: '' },
    ],
        'ADAPTABILITY' : [
            { title: 'EMOTIONAL INTELLIGENCE', value: '10', key: 'EI', desc: '' },
            { title: 'RESILIENCE', value: '10', key: 'RL', desc: '' },
            { title: 'LEARNING APTITUDE', value: '10', key: 'LA', desc: '' },
        ],
            'ALERTNESS' : [
                { title: 'GENERAL AWARENESS', value: '10', key: 'GA', desc: '' },
                { title: 'CRITICAL THINKING', value: '10', key: 'CT', desc: '' },
                { title: 'GENERAL KNOWLEDGE', value: '10', key: 'GK', desc: '' },
            ],
                '': [
                    {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
                ]
},
performanceData: {
    'GOALS': [
                { title: 'KPIs', value: '10', key: 'KP', desc:'(Reflect on the goals set and assess the extent to which they were achieved)' },
                { title: 'QUALITY', value: '10', key: 'QU', desc:'(Evaluate the quality and accuracy of your contribution, considering any feedback received)' },
                { title: 'IMPACT', value: '10', key: 'IM', desc:'(Reflect on how your work contributed to the overall goals and success measures)' },
            ],
    'SKILL' : [
        { title: 'IQ', value: '10', key: 'IQ', desc: 'Intelligence Quotient to operate as per the complexity of the role' },
        { title: 'TQ', value: '10', key: 'TQ', desc: 'Technical Quotient to have necessary skills to work on tasks' },
    ],
        'WILL' : [
            { title: 'XQ', value: '10', key: 'XQ', desc: 'Experience within the role with required functional and behavioural abilities' },
            { title: 'MQ', value: '10', key: 'MQ', desc: 'Motivation and willingness to operate in the role with drive' },
        ],
            'EFFORT' : [
                { title: 'PQ', value: '10', key: 'PQ', desc: 'Performance demonstrated in the role previously' },
                { title: 'LQ', value: '10', key: 'LQ', desc: 'Learning as per the situation and dedicating time for personal and professional growth' },
            ],
                '': [
                    {title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)'}
                ]
},
    },

// "Rassense Demo" Organisation data start here
{
    orgId: '676d6ba37d050a001bbf0df2', //Rassense Demo Org Id
        calculationUnit : '+',
            calculationTypes : [
                { title: 'Absent', color: '#D7D7D7', value: 0, default: true },
                { title: 'Poor', color: '#DF4B65', value: -1, default: false },
                { title: 'Good, as expected', color: '#F5BB00', value: 1, default: false },
                { title: 'Exceptional', color: '#52C05E', value: 1.25, default: false }
            ],
            accessLevel:[{"label":"Participant","key":0},{"label":"Leader","key":1},{"label":"Hr","key":2}],
    appraisalData : {
        'Performance Measures' : [
            { title: 'Objective 1', value: '10', key: 'O1' },
            { title: 'Objective 2', value: '10', key: 'O2' },
            { title: 'Objective 3', value: '10', key: 'O3' },
            { title: 'Objective 4', value: '10', key: 'O4' },
            { title: 'Objective 5', value: '10', key: 'O5' },
        ],
        'Personal Competencies' : [
            { title: 'Visionary Thinking', value: '10', key: 'VT' },
            { title: 'Integrity', value: '10', key: 'IG' },
            { title: 'Adaptability', value: '10', key: 'AD' },
            { title: 'Emotional Intelligence', value: '10', key: 'EI' },
            { title: 'Decisiveness', value: '10', key: 'DC' },
        ]
    },
    fitmentData: {
        'ABILITY' : [
            { title: 'FUNCTIONAL SKILLS PROFICIENCY', value: '10', key: 'FR', desc: '(e.g., skill assessment scores, certifications)' },
            { title: 'ROLE-SPECIFIC KNOWLEDGE', value: '10', key: 'RK', desc: '(e.g., years of experience, relevant training)' },
            { title: 'RELEVANT EXPERIENCE', value: '10', key: 'RE', desc: '(e.g., past performance reviews, project completion rates)' },
        ],
            'Integrity' : [
                { title: 'ETHICS', value: '10', key: 'IR', desc: '(e.g., honesty, reliability, trust)' },
                { title: 'COMPLIANCE', value: '10', key: 'MO', desc: '(e.g., adherence to Policies, fairness)' },
                { title: 'RELIABILITY', value: '10', key: 'SP', desc: '(e.g., attendance, availability for mentoring, team support)' },
            ],
                'Visionary Thinking' : [
                    { title: 'BEHAVIOURAL ATTRIBUTES', value: '10', key: 'BA', desc: '(e.g., behavioral assessment scores, peer reviews)' },
                    { title: 'COGNITIVE COMPLEXITY', value: '10', key: 'CC', desc: '(e.g., problem-solving abilities, decision-making skills)' },
                    { title: 'LEARNING APTITUDE', value: '10', key: 'LA', desc: '(e.g., continuous learning initiatives, adaptability scores)' },
                ],
                    '': [
                        { title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)' }
                    ]
    },
    successionData: {
        'ADAPTABILITY' : [
            { title: 'TRANSITION ABILITY', value: '10', key: 'TA', desc: '(e.g., successful role transitions, project management adaptability)' },
            { title: 'KNOWLEDGE READINESS', value: '10', key: 'KR', desc: '(e.g., readiness scores, role-specific knowledge)' },
            { title: 'SELF AWARENESS', value: '10', key: 'RE', desc: '(e.g., self-assessment scores, leadership review)' },
        ],
            'EMOTIONAL INTELLIGENCE' : [
                { title: 'EMOTIONAL INTELLIGENCE', value: '10', key: 'EI', desc: '(e.g., EI assessments, conflict resolution skills)' },
                { title: 'RESILIENCE', value: '10', key: 'RL', desc: '(e.g., stress management scores, recovery from setbacks)' },
                { title: 'LEARNING APTITUDE', value: '10', key: 'LA', desc: '(e.g., participation in learning programs, adaptability scores)' },
            ],
                'DECISIVENESS' : [
                    { title: 'GENERAL AWARENESS', value: '10', key: 'GA', desc: '(e.g., market & industry awareness, internal organizational knowledge)' },
                    { title: 'CRITICAL THINKING', value: '10', key: 'CT', desc: '(e.g., innovative thinking, problem-solving records)' },
                    { title: 'GENERAL KNOWLEDGE', value: '10', key: 'GK', desc: '(e.g., breadth of knowledge in relevant areas)' },
                ],
                    '': [
                        { title: 'X-FACTOR', value: '10', key: 'XF', desc: '(Anything special beyond the scope of defined indicators. Scarce skills, Special Referral, etc.)' }
                    ]
    },
    performanceData: {
        'Performance' : [
            { title: 'Objective 1', value: '10', key: 'O1' },
            { title: 'Objective 2', value: '10', key: 'O2' },
            { title: 'Objective 3', value: '10', key: 'O3' },
            { title: 'Objective 4', value: '10', key: 'O4' },
            { title: 'Objective 5', value: '10', key: 'O5' },
        ],
        'SKILL' : [
            { title: 'IQ', value: '10', key: 'IQ', desc: 'Intelligence Quotient to operate as per the complexity of the role' },
            { title: 'TQ', value: '10', key: 'TQ', desc: 'Technical Quotient to have necessary skills to work on tasks' },
        ],
        'WILL' : [
            { title: 'XQ', value: '5', key: 'XQ', desc: 'Experience within the role with required functional and behavioural abilities' },
            { title: 'MQ', value: '5', key: 'MQ', desc: 'Motivation and willingness to operate in the role with drive' },
        ],
        'EFFORT' : [
            { title: 'PQ', value: '10', key: 'PQ', desc: 'Performance demonstrated in the role previously' },
            { title: 'LQ', value: '10', key: 'LQ', desc: 'Learning as per the situation and dedicating time for personal and professional growth' },
        ],
    },
},
    // "Rassense Demo" Organisation Data Ends Here
]

function kvdrOrgConfig(_id) {
    const result = assessmentData.filter(d => d.orgId === _id);
    if (result.length) {
        return result[0];
    }
    else {
        return defaultAssessmentData;
    }
}

export { kvdrOrgConfig };